module.exports = __webpack_public_path__ + "img/solution_subsystem_05@2x.7eba61cd.png";